import { isRouteErrorResponse, Link, useRouteError } from "react-router";
import { Copy } from "@/copy/copy";

/**
 * The global error boundary (react-router `errorElement`). It uses no providers, so it also works
 * when the error came from one of them.
 */
export function RouteError() {
  const error = useRouteError();
  const notFound = isRouteErrorResponse(error) && error.status === 404;
  return (
    <div className="wp-auth" data-testid="route-error">
      <div className="wp-auth-card" role="alert">
        <h1>{notFound ? "Page not found" : "Something went wrong"}</h1>
        <p className="sub">
          {notFound
            ? "We couldn't find that page."
            : "This page hit an unexpected error. Reloading usually fixes it; your data is safe."}
        </p>
        <div style={{ display: "flex", gap: 10 }}>
          {!notFound && (
            <button type="button" className="wp-btn" onClick={() => window.location.reload()}>
              Reload
            </button>
          )}
          <Link className="wp-btn g" to="/app">
            Go to your plan
          </Link>
        </div>
      </div>
    </div>
  );
}

/** The 404 inside the app (`/app/*`); everything else falls through to the site's 404. */
export function AppNotFound() {
  return (
    <section className="page on" data-testid="not-found">
      <div className="card pad" style={{ maxWidth: 560, margin: "40px auto" }}>
        <Copy k="pages.notfound.title" as="h1" style={{ fontSize: 24, marginBottom: 6 }} />
        <Copy k="pages.notfound.sub" as="p" className="mut" style={{ marginBottom: 16 }} />
        <Link className="btn" to="/app">
          Go to your dashboard
        </Link>
      </div>
    </section>
  );
}
